module.exports = __webpack_public_path__ + "img/xiaomi12timage4mobile.7d5e6713.png";